<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Cracks in the Pavement</span></p>
<p class="p0">By Francis Gideon</p>
<p class="p2"><a id="a3"></a><a href="#/005#a25">Chapter 1</a></p>
<p class="p2"><a href="#/006#a26">Chapter 2</a></p>
<p class="p2"><span href="#/007#a27" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p2"><span href="#/008#a29" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p2"><span href="#/009#a30" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p2"><span href="#/010#a31" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p2"><span href="#/011#a32" title="Link target outside of Sample">Chapter 7</span></p>
<p class="p2"><span href="#/012#a33" title="Link target outside of Sample">Chapter 8</span></p>
<p class="p2"><span href="#/013#a34" title="Link target outside of Sample">Chapter 9</span></p>
<p class="p2"><span href="#/014#a35" title="Link target outside of Sample">Chapter 10</span></p>
<p class="p2"><span href="#/015#a36" title="Link target outside of Sample">Chapter 11</span></p>
<p class="p2"><span href="#/016#a37" title="Link target outside of Sample">Chapter 12</span></p>
<p class="p2"><span href="#/017#a38" title="Link target outside of Sample">Chapter 13</span></p>
<p class="p2"><span href="#/018#a39" title="Link target outside of Sample">Chapter 14</span></p>
<p class="p2"><span href="#/019#a40" title="Link target outside of Sample">Chapter 15</span></p>
<p class="p2"><span href="#/020#a41" title="Link target outside of Sample">Chapter 16</span></p>
<p class="p2"><span href="#/021#a42" title="Link target outside of Sample">Chapter 17</span></p>
<p class="p2"><span href="#/022#a43" title="Link target outside of Sample">Chapter 18</span></p>
<p class="p2"><span href="#/023#a44" title="Link target outside of Sample">Chapter 19</span></p>
<p class="p2"><span href="#/024#a45" title="Link target outside of Sample">Epilogue</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?2fc1ab90